import React from 'react';
import {FormattedMessage} from 'react-intl';
import {FlexColumn, Modal, Text} from '@forecast-it/design-system';
import {useRouterPrompt, UseRouterPromptProps} from '../../../shared/hooks/useRouterPrompt';

export type SaveReportPromptProps = UseRouterPromptProps;
export const SaveReportPrompt = ({
	hasChanges,
	onSave,
	onSaveAs,
	onDiscard,
}: SaveReportPromptProps): React.JSX.Element | null => {
	const {showPrompt, handleSave, handleSaveAs, handleDiscard, closePrompt} = useRouterPrompt({
		hasChanges,
		onSave,
		onSaveAs,
		onDiscard,
		ignoreChildPaths: true,
	});
	return showPrompt ? (
		<Modal onCloseModal={handleDiscard}>
			<Modal.Title>
				<FormattedMessage id={'common.save_changes'} />
			</Modal.Title>
			<Modal.Content>
				<FlexColumn>
					<Text>
						<FormattedMessage id={'common.save_changes_text'} />
					</Text>
				</FlexColumn>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton
					onPress={() => {
						closePrompt();
						handleSave();
					}}
				>
					<FormattedMessage id={'common.save'} />
				</Modal.PrimaryFooterButton>
				{onSaveAs && (
					<Modal.SecondaryFooterButton
						onPress={() => {
							closePrompt();
							handleSaveAs();
						}}
					>
						<FormattedMessage id={'saved_report.save_as'} />
					</Modal.SecondaryFooterButton>
				)}
				<Modal.TertiaryFooterButton onPress={handleDiscard}>
					<FormattedMessage id={'common.discard'} />
				</Modal.TertiaryFooterButton>
			</Modal.Footer>
		</Modal>
	) : null;
};
